import { render, staticRenderFns } from "./OperaAboutServeWindow.vue?vue&type=template&id=3c00b67d&scoped=true&"
import script from "./OperaAboutServeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaAboutServeWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaAboutServeWindow.vue?vue&type=style&index=0&id=3c00b67d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00b67d",
  null
  
)

export default component.exports